<div 
    [class.bt-25]="percents >= 25"
    [class.bt-50]="percents >= 50"
    [class.bt-75]="percents >= 75"
    class="progress-bar" 
    [style]="'--p:' + percents">
    <h3>{{ percents | number:'1.0-0' }}%</h3>
</div>